import { createContext, useContext } from "react";

interface ProductTabularViewModalNavigation {
  open: () => void;
  close: () => void;
}

const ProductTabularViewModalContext = createContext<ProductTabularViewModalNavigation>({
  open: () => {},
  close: () => {},
});

export const ProductTabularViewModalProvider = ProductTabularViewModalContext.Provider;

export const useProductTabularViewModalOpen = () => useContext(ProductTabularViewModalContext).open;
export const useProductTabularViewModalClose = () => useContext(ProductTabularViewModalContext).close;
